/* ご試着の申し込み（2026-10-20）。snippets/lounge-try-on.liquid の動き。
   ・「試着希望」に印 → 購入ボタンの2行目に「試着を希望する」
   ・購入ボタンを押すと、予約の確認と同じ形の窓（作品・サイズの表、条件の全文は開閉）。全文の一番下の「上記の内容に同意する」に印を付けて
     「カートへ追加する」を押すと、注文に残す項目（disabled にしてある hidden）を有効にして出し直す
   ・予約販売のサイズを選んだら選べなくする（lounge-preorder の states を読む）
   見張りは lounge-preorder.js と同じく、Aurora が FormData を集める前（capture）で行う。 */
(() => {
  if (customElements.get('lounge-try-on')) return;
  const pad = n => String(n).padStart(2, '0');
  const stamp = () => {
    const d = new Date(), o = -d.getTimezoneOffset(), sign = o >= 0 ? '+' : '-';
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())} ${sign}${pad(Math.floor(Math.abs(o) / 60))}:${pad(Math.abs(o) % 60)}`;
  };
  customElements.define('lounge-try-on', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.component = this.closest('product-form');
      this.form = this.closest('form');
      this.root = this.closest('product-info') || this.component;
      this.want = this.querySelector('[data-lounge-try-on-want]');
      if (!this.component || !this.form || !this.want) return;
      this.why = this.querySelector('[data-lounge-try-on-why]');
      this.confirm = this.querySelector('[data-lounge-try-on-confirm]');
      this.agree = this.querySelector('[data-lounge-try-on-agree]');
      this.go = this.querySelector('[data-lounge-try-on-go]');
      this.error = this.querySelector('[data-lounge-try-on-error]');
      this.size = this.querySelector('[data-lounge-try-on-size]');
      this.terms = this.querySelector('.lounge-try-on__terms');
      this.props = [...this.querySelectorAll('[data-lounge-try-on-prop]')];
      this.stampInput = this.querySelector('[data-lounge-try-on-stamp]');
      try { this.sizes = JSON.parse(this.querySelector('[data-lounge-try-on-sizes]')?.textContent || '{}'); } catch { this.sizes = {}; }
      this.off = this.want.disabled;
      this.agreed = false;
      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.want.addEventListener('change', () => this.update(), { signal });

      /* サイズを選び直したら、予約販売かどうかを見直す。Aurora は変種の ID を同じ処理の中で書き換えるので、一拍おいて読む */
      this.root.addEventListener('change', event => {
        if (this.contains(event.target)) return;
        setTimeout(() => this.check(), 0);
      }, { signal });

      this.component.addEventListener('submit', event => {
        if (!this.want.checked || !this.confirm || this.agreed) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.ask();
      }, { capture: true, signal });

      if (this.confirm) {
        this.agree?.addEventListener('change', () => {
          this.go?.setAttribute('aria-disabled', this.agree.checked ? 'false' : 'true');
          if (this.agree.checked && this.error) this.error.hidden = true;
        }, { signal });
        /* 全文を開いたら、上の案内文をたたみ、そのぶん全文の枠を窓いっぱいまで広げる（スマホで枠が狭すぎた・2026-10-20 本人） */
        this.terms?.addEventListener('toggle', () => this.fit(this.terms.open), { signal });
        window.addEventListener('resize', () => { if (this.terms?.open && this.confirm.open) this.fit(true); }, { signal });
        this.querySelector('[data-lounge-try-on-close]')?.addEventListener('click', () => this.confirm.close(), { signal });
        /* 枠の外（まわりの暗がり）を押しても閉じる */
        this.confirm.addEventListener('click', event => { if (event.target === this.confirm) this.confirm.close(); }, { signal });
        this.go?.addEventListener('click', () => {
          if (!this.agree?.checked) {
            /* 黙って何も起きないのがいちばん困る。理由を出して、同意の印のところへ連れていく */
            /* 同意の印は条件の全文の一番下。閉じていれば開いて、印のところまで送る */
            if (this.error) this.error.hidden = false;
            if (this.terms) this.terms.open = true;
            this.fit(true);
            this.agree?.scrollIntoView({ block: 'center', behavior: 'smooth' });
            this.agree?.focus({ preventScroll: true });
            return;
          }
          if (this.stampInput) this.stampInput.value = stamp();
          this.props.forEach(input => { input.disabled = false; });
          this.agreed = true;
          this.confirm.close();
          /* 出し直す。上の見張りは agreed を見て、こんどは通す。FormData はこの中で集められるので、終わったら元に戻す */
          this.form.requestSubmit(this.form.querySelector('button[name="add"]') || undefined);
          setTimeout(() => {
            this.agreed = false;
            this.props.forEach(input => { input.disabled = true; });
          }, 0);
        }, { signal });
      }

      /* テーマが購入ボタンを作り直しても、2行目の言葉を付け直す */
      this.observer = new MutationObserver(() => this.label());
      this.observer.observe(this.component, { childList: true, subtree: true });
      this.check();
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
    ask() {
      /* 表のサイズは選んだものを開くたびに書き直す。サイズの無い商品（Default Title）は行ごと隠す */
      if (this.size) {
        const id = this.form.querySelector('[data-product-form-variant]')?.value;
        const size = String(this.sizes[id] || '').split(/[（(]/)[0].trim();
        const none = !size || size === 'Default Title';
        this.size.textContent = none ? '' : size;
        this.size.hidden = none;
        if (this.size.previousElementSibling) this.size.previousElementSibling.hidden = none;
      }
      this.terms?.removeAttribute('open');
      this.fit(false);
      this.querySelector('[data-lounge-try-on-scroll]')?.scrollTo(0, 0);
      if (this.agree) this.agree.checked = false;
      this.go?.setAttribute('aria-disabled', 'true');
      if (this.error) this.error.hidden = true;
      if (this.confirm.open) return;
      if (typeof this.confirm.showModal === 'function') this.confirm.showModal();
      else this.confirm.setAttribute('open', '');
      this.confirm.querySelector('.lounge-try-on__confirm-inner')?.scrollTo(0, 0);
    }
    /* 枠の高さは、窓（画面の高さ − 48px）に全部が収まるところまで。いったん上限の 640px にして、はみ出した分だけ縮める */
    fit(open) {
      const box = this.querySelector('[data-lounge-try-on-scroll]');
      const inner = this.confirm?.querySelector('.lounge-try-on__confirm-inner');
      this.confirm?.classList.toggle('is-reading', open);
      if (!box || !inner) return;
      box.style.maxHeight = open ? '640px' : '';
      if (!open || !this.confirm.open) return;
      const over = inner.scrollHeight - inner.clientHeight;
      if (over > 0) box.style.maxHeight = `${Math.max(240, 640 - over)}px`;
    }
    preorder() {
      const node = this.component.querySelector('[data-lounge-preorder-states]');
      if (!node) return false;
      try {
        const id = this.form.querySelector('[data-product-form-variant]')?.value;
        return JSON.parse(node.textContent)[id]?.mode === 'preorder';
      } catch { return false; }
    }
    check() {
      if (this.classList.contains('is-off') && !this.confirm) return;     // 海外のお届け先（Liquid 側で止めてある）
      const off = this.preorder();
      if (off === this.off) return;
      this.off = off;
      this.want.disabled = off;
      if (off) this.want.checked = false;
      if (this.why) this.why.textContent = off ? (this.dataset.offPreorder || '') : '';
      this.classList.toggle('is-off', off);
      this.update();
    }
    label() {
      const text = this.dataset.buttonLabel || '';
      this.component.querySelectorAll('button[name="add"]').forEach(button => {
        if (button.getAttribute('data-lounge-try-on-label') !== text) button.setAttribute('data-lounge-try-on-label', text);
      });
    }
    update() {
      const on = this.want.checked;
      this.classList.toggle('is-on', on);
      this.component.classList.toggle('lounge-try-on--on', on);
      this.label();
    }
  });
})();
